import { Injectable } from "@angular/core";

import MapPercentageServiceMock from "@app/core/services/map-percentage/map-percentage.service.mock";

@Injectable({providedIn: 'root'})
export default class MapPercentageService extends MapPercentageServiceMock {}
